import React from "react";
import GP1 from "../../../assets/GP/GP1.png";
import GP2 from "../../../assets/GP/GP2.png";
import GP3 from "../../../assets/GP/GP3.png";
import demo from "../../../assets/GP/GPDemo.gif";

const GreenPlatter = () => {
  return (
    <div className="pt-16 mx-3 md:mx-8">
      <h1 className="text-4xl mb-8 font-black text-lightBrown md:text-6xl md:mb-16 ">
        GreenPlatter
      </h1>
      {/* <p>
        GreenPlatter is an AI-powered platform that empowers diabetic patients
        by providing real-time, personalized meal plans tailored to their blood
        glucose levels, acting as a dietician in their pocket.
      </p> */}
      <div className="mx-4 md:mx-0">
        {/*---------------------------- mobile view table  ----------------------------*/}
        <table
          className="md:hidden mx-2 my-4 text-sm"
          style={{ borderSpacing: "1 0" }}
        >
          <tbody>
            <tr>
              <td className=" p-1 align-top w-1/2">
                <h2 className="font-bold underline">ROLE</h2>
                <p> Front-End Software Engineer Intern</p>
              </td>
              <td className=" p-1 align-top w-1/2">
                <h2 className="underline font-bold ">RESPONSIBILITIES</h2>
                <p>Developed dynamic web pages using HTML and CSS</p>
              </td>
            </tr>
          </tbody>
        </table>

        <div className=" flex flex-col mb:mb-4 md:flex-row md:mx-10">
          <img
            src={demo}
            alt="GP1"
            className=" rounded-xl object-contain w-full max-w-full h-auto  md:w-1/2 md:h-auto "
          />
          <div className="md:flex md:items-center">
            <p className="text-center py-8 text-lg md:pl-8  md:text-2xl">
              Developed a promotional website using HTML and CSS were undertaken
              to effectively showcase GreenPlatter's innovative solutions and
              enhance its connection with the target audience.
            </p>
          </div>
        </div>

        {/*---------------------------- desktop view table ----------------------------*/}
        <table
          className="hidden md:block border-separate mx-[8%] my-16 "
          style={{ borderSpacing: "6rem 0" }}
        >
          <tbody>
            <tr>
              <td className="p-4 text-lg align-top w-1/2">
                <h2 className="font-bold text-xl underline">ROLE</h2>
                <p> Front-End Software Engineer Intern</p>
              </td>
              <td className=" p-4 text-lg align-top w-1/2">
                <h2 className="underline font-bold text-xl">
                  RESPONSIBILITIES
                </h2>
                <p>Developed dynamic web pages using HTML and CSS</p>
              </td>
            </tr>
          </tbody>
        </table>
        {/*---------------------------- screenshots of projects ----------------------------*/}
        <div>
          <h2 className="text-pink font-bold  text-center pb-4 text-xl md:text-2xl">
            {" "}
            - - Website Snapshot - -
          </h2>
          <img src={GP1} alt="GP1" className="mb-8 rounded-xl" />
          <img src={GP2} alt="GP2" className="mb-8 rounded-xl" />
          <img src={GP3} alt="GP3" className="mb-8 rounded-xl" />
        </div>
      </div>
    </div>
  );
};

export default GreenPlatter;
